module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("奖金积分提现 (余额" + _vm._s(_vm.bonusValue) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("银行卡提现")]), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("提现金额：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reflectMoney),
      expression: "reflectMoney"
    }],
    staticClass: "input",
    staticStyle: {
      "ime-mode": "Disabled"
    },
    attrs: {
      "type": "text",
      "maxlength": "60",
      "name": "payCode",
      "placeholder": "请输入提现金额(需100整数倍)"
    },
    domProps: {
      "value": (_vm.reflectMoney)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.reflectMoney = $event.target.value
      }, _vm.getCalGold]
    }
  }), _vm._v(" "), (_vm.calGold) ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000"
    }
  }, [_vm._v("税后实际提交金额：" + _vm._s(_vm.calGold))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idName),
      expression: "idName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "60",
      "name": "payCode"
    },
    domProps: {
      "value": (_vm.idName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("身份证号码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idNumber),
      expression: "idNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "60",
      "name": "payCode"
    },
    domProps: {
      "value": (_vm.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ptb5 flowhid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_c('div', [_c('Upload', {
    ref: "upload",
    attrs: {
      "show-upload-list": false,
      "on-success": _vm.handleFontImgSuccess,
      "format": ['jpg', 'jpeg', 'png'],
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "on-format-error": _vm.handleFormatError,
      "before-upload": _vm.handleBeforeUpload,
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idFrontImage),
      expression: "idFrontImage"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.idFrontImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idFrontImage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.noFrontImg == true ? 'no-img' : '',
    attrs: {
      "src": (_vm.idFrontImageUrl || _vm.idFrontImage) ? (_vm.idFrontImageUrl || _vm.idFrontImage) : _vm.defaultFontUrl
    }
  }), _vm._v(" "), _c('span', [_vm._v("证件正面")])])], 1), _vm._v(" "), _c('div', [_c('Upload', {
    ref: "upload",
    attrs: {
      "show-upload-list": false,
      "on-success": _vm.handleBackImgSuccess,
      "format": ['jpg', 'jpeg', 'png'],
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "on-format-error": _vm.handleFormatError,
      "before-upload": _vm.handleBeforeUpload,
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idBackImage),
      expression: "idBackImage"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.idBackImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idBackImage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.noBackImg == true ? 'no-img' : '',
    attrs: {
      "src": (_vm.idBackImageUrl || _vm.idBackImage) ? (_vm.idBackImageUrl || _vm.idBackImage) : _vm.defaultBackUrl
    }
  }), _vm._v(" "), _c('span', [_vm._v("证件反面")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("支付宝姓名：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trueName),
      expression: "trueName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.trueName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trueName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("支付宝账号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alipayName),
      expression: "alipayName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.alipayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alipayName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("验证码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payCode),
      expression: "payCode"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')",
      "onafterpaste": "this.value=this.value.replace(/\\D/g,'')"
    },
    domProps: {
      "value": (_vm.payCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payCode = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeShow),
      expression: "codeShow"
    }],
    staticClass: "code-sty",
    on: {
      "click": _vm.getCodeHandler
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeShow),
      expression: "!codeShow"
    }],
    staticClass: "code-sty grey-sty"
  }, [_vm._v(_vm._s(_vm.count) + " s")])]), _vm._v(" "), _c('p', [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageContent),
      expression: "messageContent"
    }],
    staticClass: "ivu-input bonusTextArea",
    attrs: {
      "name": "content",
      "placeholder": "",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.messageContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "yellow_btn",
    attrs: {
      "type": "button",
      "value": "立即提现"
    },
    on: {
      "click": _vm.confirmBankCash
    }
  })])])])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "tit"
  }, [_vm._v("身份证照片：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tit"
  }, [_c('div', {
    staticClass: "tit_inner",
    staticStyle: {
      "top": "0"
    }
  }, [_vm._v("留言信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n          提现规则:"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("为便于申报税费，每月5号、10号、15号、20号开放提现功能，其他时间不能提现。")]), _c('br'), _vm._v("\n          根据国家对企业上市规范要求和按国家税务个人劳务报酬所得税收预扣预缴税率表:"), _c('br'), _vm._v("\n          1、当月累计提现不超过20000元的，按照税法扣除20%的税费:"), _c('br'), _vm._v("\n          2、当月累计提现不超过20000元至50000元的部分，按照税法扣除30%的税费;"), _c('br'), _vm._v("\n          3、当月累计提现超过50000元的部分，按照税法扣除40%的税费。\"\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6061b7a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/bonusCash.vue
// module id = 1615
// module chunks = 1